// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"499":"Download","962":"home"}[chunkId] || chunkId) + "." + {"499":"132a9051","828":"61875654","962":"5278bbb7"}[chunkId] + ".css";
};